import { render } from "./FormularioPeriodoAvaliacao.vue?vue&type=template&id=d9545f4e&scoped=true"
import script from "./FormularioPeriodoAvaliacao.vue?vue&type=script&lang=js"
export * from "./FormularioPeriodoAvaliacao.vue?vue&type=script&lang=js"

import "./FormularioPeriodoAvaliacao.vue?vue&type=style&index=0&id=d9545f4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9545f4e"]])

export default __exports__